<template>
  <transition :name="transition" class="d-inline-block">
    <div v-if="change" key="1">
      {{ value1 }}
    </div>
    <div v-else key="2">
      {{ value2 }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    value: { type: [String, Number, Boolean], default: null }
  },
  data: () => ({
    value1: null,
    value2: null,
    change: null,
    transition: 'counter-up',
  }),
  watch: {
    value() {
      let valuePrev = null;
      if (this.change) {
        valuePrev = this.value1;
        this.value2 = this.value;
      } else {
        valuePrev = this.value2;
        this.value1 = this.value;
      }

      const dir = this.$tools.string.compare(valuePrev, this.value);
      this.transition = dir > 0 ? 'counter-up' : 'counter-down';
      this.change = !this.change;
    }
  },
  mounted() {
    this.value1 = this.value;
    this.value2 = this.value;
  },
};
</script>

<style lang="scss" scoped>
.counter-up-enter-active { transition: all 0.3s; }
.counter-up-leave-active { transition: all 0.3s; position: absolute}
.counter-up-enter  {transform: translateY(200%);}
.counter-up-leave-to { transform: translateY(-200%); font-size: 50%; opacity: 0;}

.counter-down-enter-active { transition: all 0.3s; }
.counter-down-leave-active { transition: all 0.3s; position: absolute}
.counter-down-enter  {transform: translateY(-200%); opacity: 0;}
.counter-down-leave-to { transform: translateY(200%); font-size: 50%; }
</style>
